import { useState } from "react";
import * as api from "./api";
import { BrandPicker } from "./brand";
import { G, A, ALt, Svg, iX, Toast } from "./shared";

var COLUMNS = [
  { key: "name", label: "회사명", required: true },
  { key: "bizNo", label: "사업자번호" },
  { key: "project", label: "프로젝트명", required: true },
  { key: "ceo", label: "대표자" },
  { key: "ceoPhone", label: "대표자 연락처" },
  { key: "ceoEmail", label: "대표자 이메일" },
  { key: "manager", label: "담당자" },
  { key: "managerPhone", label: "담당자 연락처" },
  { key: "managerEmail", label: "담당자 이메일" },
  { key: "referrer", label: "소개자" },
  { key: "refPhone", label: "소개자 연락처" },
  { key: "refEmail", label: "소개자 이메일" },
  { key: "deadline", label: "기한(YYYY-MM-DD)" }
];

function parseCsv(text) {
  var lines = text.split("\n").map(function(l) { return l.replace(/\r$/, ""); });
  if (lines.length < 2) return [];
  var headers = lines[0].split(",").map(function(h) { return h.trim(); });
  var headerMap = {};
  COLUMNS.forEach(function(col) {
    var idx = headers.indexOf(col.label);
    if (idx >= 0) headerMap[col.key] = idx;
  });
  var rows = [];
  for (var i = 1; i < lines.length; i++) {
    if (!lines[i].trim()) continue;
    var cells = lines[i].split(",");
    var row = {};
    COLUMNS.forEach(function(col) {
      if (headerMap[col.key] !== undefined) {
        row[col.key] = (cells[headerMap[col.key]] || "").trim().replace(/^"|"$/g, "");
      } else {
        row[col.key] = "";
      }
    });
    rows.push(row);
  }
  return rows;
}

function validateRow(row) {
  var errors = [];
  if (!row.name || !row.name.trim()) errors.push("회사명");
  if (!row.project || !row.project.trim()) errors.push("프로젝트명");
  var biz = (row.bizNo || "").replace(/[^0-9]/g, "");
  if (biz && biz.length !== 10) errors.push("사업자번호(" + biz.length + "자)");
  return errors;
}

export default function BulkRegisterModal({ templates, onClose, onDone }) {
  var [rows, setRows] = useState([]);
  var [globalTpl, setGlobalTpl] = useState("");
  var [globalBrand, setGlobalBrand] = useState("roum"); // 고객 화면 로고 — 전체 행 공통 (2026-09-11)
  var [submitting, setSubmitting] = useState(false);
  var [result, setResult] = useState(null);
  var [toast, setToast] = useState("");

  function showToast(msg) { setToast(msg); setTimeout(function() { setToast(""); }, 3000); }

  function downloadTemplate() {
    var header = COLUMNS.map(function(c) { return c.label; }).join(",");
    var sample = "주식회사 예시,123-45-67890,세무자료수집,홍길동,010-1234-5678,ceo@example.com,김담당,010-8765-4321,mgr@example.com,박소개,010-1111-2222,fp@example.com,2026-03-15";
    var csv = "\uFEFF" + header + "\n" + sample + "\n";
    var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    var url = URL.createObjectURL(blob);
    var a = document.createElement("a");
    a.href = url;
    a.download = "대량등록_템플릿.csv";
    a.click();
    URL.revokeObjectURL(url);
  }

  function handleFile(e) {
    var file = e.target.files[0];
    if (!file) return;
    var reader = new FileReader();
    reader.onload = function(ev) {
      try {
        var parsed = parseCsv(ev.target.result);
        if (parsed.length === 0) { showToast("데이터가 없습니다. 헤더 행 확인해주세요."); return; }
        if (parsed.length > 50) { showToast("최대 50건까지 가능합니다. (현재 " + parsed.length + "건)"); parsed = parsed.slice(0, 50); }
        setRows(parsed);
        setResult(null);
      } catch (err) {
        showToast("파일 파싱 오류: " + err.message);
      }
    };
    reader.readAsText(file, "UTF-8");
  }

  function removeRow(idx) {
    setRows(function(p) { return p.filter(function(_, i) { return i !== idx; }); });
  }

  async function doSubmit() {
    if (rows.length === 0) return;
    var hasError = false;
    rows.forEach(function(r) { if (validateRow(r).length > 0) hasError = true; });
    if (hasError) { showToast("오류가 있는 행을 수정하거나 제거해주세요."); return; }

    setSubmitting(true);
    try {
      var payload = rows.map(function(r) {
        return Object.assign({}, r, { templateId: globalTpl || "", brand: globalBrand || "roum" });
      });
      var res = await api.bulkCreate(payload);
      setResult(res);
      if (res.created && res.created.length > 0) {
        showToast(res.created.length + "건 등록 완료" + (res.errors.length > 0 ? ", " + res.errors.length + "건 오류" : ""));
      }
    } catch (err) {
      showToast("등록 오류: " + err.message);
    } finally {
      setSubmitting(false);
    }
  }

  var validCount = rows.filter(function(r) { return validateRow(r).length === 0; }).length;

  var overlayS = { position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(0,0,0,.45)", zIndex: 9000, display: "flex", justifyContent: "center", alignItems: "center" };
  var modalS = { background: "#fff", borderRadius: 16, width: "90%", maxWidth: 900, maxHeight: "90vh", overflow: "auto", padding: 24, position: "relative" };

  return (
    <div style={overlayS} onClick={function(e) { if (e.target === e.currentTarget) onClose(); }}>
      <Toast msg={toast} />
      <div style={modalS}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
          <h2 style={{ margin: 0, fontSize: 18, color: G[800] }}>대량 등록</h2>
          <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", padding: 4 }}><Svg d={iX} s={20} c={G[500]} /></button>
        </div>

        {/* Step 1: 템플릿 다운로드 + 파일 업로드 */}
        <div style={{ display: "flex", gap: 12, marginBottom: 16, alignItems: "center", flexWrap: "wrap" }}>
          <button onClick={downloadTemplate} style={{ padding: "10px 20px", borderRadius: 8, border: "1.5px solid " + A, background: "#fff", color: A, fontSize: 13, fontWeight: 600, cursor: "pointer", flex:1, textAlign:"center" }}>
            CSV 템플릿 다운로드
          </button>
          <label style={{ padding: "10px 20px", borderRadius: 8, border: "none", background: A, color: "#fff", fontSize: 13, fontWeight: 600, cursor: "pointer", flex:1, textAlign:"center" }}>
            CSV 파일 업로드
            <input type="file" accept=".csv" onChange={handleFile} style={{ display: "none" }} />
          </label>
          {rows.length > 0 && <span style={{ fontSize: 13, color: G[600] }}>{rows.length}건 로드됨 (유효 {validCount}건)</span>}
        </div>

        {/* 템플릿 선택 (전체 적용) */}
        {rows.length > 0 && (
          <div style={{ marginBottom: 12, display: "flex", alignItems: "center", gap: 8 }}>
            <span style={{ fontSize: 12, color: G[600] }}>수집항목 템플릿 (전체 적용):</span>
            <select value={globalTpl} onChange={function(e) { setGlobalTpl(e.target.value); }} style={{ padding: "6px 10px", border: "1px solid " + G[200], borderRadius: 6, fontSize: 12, background: "#fff" }}>
              <option value="">없음 (항목 없이 등록)</option>
              {templates.map(function(t) {
                return <option key={t.id} value={t.id}>{t.name} ({t.itemCount || 0}개)</option>;
              })}
            </select>
            <BrandPicker size="sm" label="고객 화면 로고 (전체 적용):" value={globalBrand} onChange={setGlobalBrand} style={{ marginLeft: 6 }} />
          </div>
        )}

        {/* Step 2: 미리보기 테이블 */}
        {rows.length > 0 && (
          <div style={{ overflow: "auto", maxHeight: 400, border: "1px solid " + G[200], borderRadius: 8 }}>
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 11 }}>
              <thead>
                <tr style={{ background: G[50], position: "sticky", top: 0 }}>
                  <th style={{ padding: "6px 8px", borderBottom: "1px solid " + G[200], textAlign: "center", width: 30 }}>#</th>
                  <th style={{ padding: "6px 8px", borderBottom: "1px solid " + G[200], textAlign: "left" }}>회사명</th>
                  <th style={{ padding: "6px 8px", borderBottom: "1px solid " + G[200], textAlign: "left" }}>사업자번호</th>
                  <th style={{ padding: "6px 8px", borderBottom: "1px solid " + G[200], textAlign: "left" }}>프로젝트명</th>
                  <th style={{ padding: "6px 8px", borderBottom: "1px solid " + G[200], textAlign: "left" }}>대표자</th>
                  <th style={{ padding: "6px 8px", borderBottom: "1px solid " + G[200], textAlign: "left" }}>담당자</th>
                  <th style={{ padding: "6px 8px", borderBottom: "1px solid " + G[200], textAlign: "left" }}>소개자</th>
                  <th style={{ padding: "6px 8px", borderBottom: "1px solid " + G[200], textAlign: "center" }}>상태</th>
                  <th style={{ padding: "6px 8px", borderBottom: "1px solid " + G[200], width: 30 }}></th>
                </tr>
              </thead>
              <tbody>
                {rows.map(function(r, i) {
                  var errs = validateRow(r);
                  var hasErr = errs.length > 0;
                  return (
                    <tr key={i} style={{ background: hasErr ? "#FEF2F2" : (i % 2 === 0 ? "#fff" : G[50]) }}>
                      <td style={{ padding: "5px 8px", borderBottom: "1px solid " + G[100], textAlign: "center", color: G[400] }}>{i + 1}</td>
                      <td style={{ padding: "5px 8px", borderBottom: "1px solid " + G[100], fontWeight: 600 }}>{r.name}</td>
                      <td style={{ padding: "5px 8px", borderBottom: "1px solid " + G[100], fontFamily: "monospace", fontSize: 10 }}>{r.bizNo}</td>
                      <td style={{ padding: "5px 8px", borderBottom: "1px solid " + G[100] }}>{r.project}</td>
                      <td style={{ padding: "5px 8px", borderBottom: "1px solid " + G[100], fontSize: 10 }}>{r.ceo}{r.ceoPhone ? " " + r.ceoPhone : ""}</td>
                      <td style={{ padding: "5px 8px", borderBottom: "1px solid " + G[100], fontSize: 10 }}>{r.manager}{r.managerPhone ? " " + r.managerPhone : ""}</td>
                      <td style={{ padding: "5px 8px", borderBottom: "1px solid " + G[100], fontSize: 10 }}>{r.referrer}{r.refPhone ? " " + r.refPhone : ""}</td>
                      <td style={{ padding: "5px 8px", borderBottom: "1px solid " + G[100], textAlign: "center" }}>
                        {hasErr ? <span style={{ color: "#DC2626", fontSize: 10 }} title={errs.join(", ")}>⚠ {errs.join(", ")}</span> : <span style={{ color: "#059669", fontSize: 10 }}>✓</span>}
                      </td>
                      <td style={{ padding: "5px 4px", borderBottom: "1px solid " + G[100] }}>
                        <button onClick={function() { removeRow(i); }} style={{ background: "none", border: "none", cursor: "pointer", padding: 0 }}><Svg d={iX} s={11} c={G[400]} /></button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}

        {/* 결과 표시 */}
        {result && (
          <div style={{ marginTop: 12, padding: 12, borderRadius: 8, background: result.errors.length > 0 ? "#FFFBEB" : "#F0FDF4", border: "1px solid " + (result.errors.length > 0 ? "#FDE68A" : "#BBF7D0") }}>
            <div style={{ fontSize: 13, fontWeight: 600, color: result.errors.length > 0 ? "#92400E" : "#166534", marginBottom: 4 }}>
              {result.created.length}건 등록 완료{result.errors.length > 0 ? ", " + result.errors.length + "건 오류" : ""}
            </div>
            {result.errors.length > 0 && (
              <div style={{ fontSize: 11, color: "#DC2626", marginTop: 4 }}>
                {result.errors.map(function(e, i) { return <div key={i}>{e.row}행: {e.error}</div>; })}
              </div>
            )}
          </div>
        )}

        {/* 하단 버튼 */}
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 16 }}>
          {result && result.created.length > 0 && (
            <button onClick={function() { onDone(); onClose(); }} style={{ padding: "10px 20px", borderRadius: 8, border: "none", background: "#059669", color: "#fff", fontSize: 13, fontWeight: 600, cursor: "pointer" }}>
              완료 (목록 새로고침)
            </button>
          )}
          {!result && rows.length > 0 && (
            <button onClick={doSubmit} disabled={submitting || validCount === 0} style={{ padding: "10px 24px", borderRadius: 8, border: "none", background: validCount > 0 ? A : G[300], color: "#fff", fontSize: 13, fontWeight: 600, cursor: validCount > 0 ? "pointer" : "default", opacity: submitting ? 0.6 : 1 }}>
              {submitting ? "등록 중..." : validCount + "건 일괄 등록"}
            </button>
          )}
          <button onClick={onClose} style={{ padding: "10px 20px", borderRadius: 8, border: "1px solid " + G[200], background: "#fff", color: G[600], fontSize: 13, cursor: "pointer" }}>닫기</button>
        </div>
      </div>
    </div>
  );
}
